import styled from "styled-components";

export const SearchBar = styled.div`
  & > div > p {
    color: ${({ theme }) => `${theme.colors.blackTextTitle}`};
    font-size: 1.4rem;
    font-weight: 600;
  }

  .search-button--container,
  .secondary-button--container {
    align-self: flex-end;
  }

  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
    width: 100%;
  }

  .react-date-picker__wrapper {
    border: none;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

interface ISearchButton {
  isLoading?: boolean;
}
export const SearchButton = styled.button<ISearchButton>`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border: none;
  border-radius: 0.8rem;
  display: flex;
  font-size: 1.4rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-left: 0.5rem;
  width: 100%;

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const SecondaryButton = styled(SearchButton)`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
  `}
`;

interface ISubtitleDiv {
  color?: string;
  fontWeight?: number;
}
export const SubtitleDiv = styled.div<ISubtitleDiv>`
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.primaryBlue};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
`;

const BaseIcon = styled.div`
  align-items: center;
  border-radius: 1rem;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 3.4rem;
  width: 3.4rem;
`;

export const ApproveIcon = styled(BaseIcon)`
  background-color: ${({ theme }) => theme.colors.accentGreen};
`;

export const EditIcon = styled(BaseIcon)`
  background-color: ${({ theme }) => theme.colors.primaryBlue};
`;

export const RejectIcon = styled(BaseIcon)`
  background-color: ${({ theme }) => theme.colors.accentRed};

  & > img {
    filter: invert(1);
  }
`;

export const ActionsDiv = styled.div`
  & > div:first-of-type {
    margin-right: 1.4rem;
  }
  margin-right: -1.6rem;

  .approve-icon {
    background-color: ${(props) => props.theme.colors.accentGreen};

    align-items: center;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    display: flex;
    height: 4.2rem;
    justify-content: center;
    width: 4.2rem;

    & > img {
      height: 2.1rem;
      width: 2.1rem;
    }

    :hover {
      background-color: ${(props) => props.theme.colors.accentGreen} !important;
      border-color: ${(props) => props.theme.colors.accentGreen} !important;
    }
  }

  .reject-icon {
    background-color: ${(props) => props.theme.colors.accentRed};

    align-items: center;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    display: flex;
    height: 4.2rem;
    justify-content: center;
    margin-left: 0.5rem;
    width: 4.2rem;

    & > img {
      filter: invert(1);
      height: 2.1rem;
      width: 2.1rem;
    }

    :hover {
      background-color: ${(props) => props.theme.colors.accentRed} !important;
      border-color: ${(props) => props.theme.colors.accentGreen} !important;
    }
  }
`;

interface IApproveButton {
  disabled?: any;
  width?: string;
  marginRight?: string;
  marginLeft?: string;
}
export const ApproveButton = styled.button<IApproveButton>`
  background-color: ${({ theme }) => theme.colors.accentGreen};
  color: ${({ theme }) => theme.colors.white};

  align-items: center;
  border: none;
  border-radius: 1rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  width: ${(props) => (props.width ? props.width : "20.6rem")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0rem")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0rem")};

  & > img {
    height: 2.1rem;
    margin-right: 1rem;
    width: 2.1rem;
  }
`;

interface IRejectButton {
  width?: string;
  marginRight?: string;
  marginLeft?: string;
}
export const RejectButton = styled.button<IRejectButton>`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
    border: solid 1px ${theme.colors.accentRed};
    color: ${theme.colors.accentRed};
  `};

  align-items: center;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  width: ${(props) => (props.width ? props.width : "20.6rem")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0rem")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0rem")};
  & > img {
    height: 1.5rem;
    margin-right: 1rem;
    width: 1.5rem;
  }
`;

interface IClearFilterButton {
  isLoading?: boolean;
}
export const ClearFilterButton = styled.button<IClearFilterButton>`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.black};
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border: none;
  border-radius: 0.8rem;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-left: 0.5rem;
  width: 100%;

  img {
    height: 2rem;
    margin-right: 1rem;
    width: 2rem;
  }
`;

interface ISectionTitle {
  light?: any;
  small?: any;
}
export const SectionTitle = styled.h3<ISectionTitle>`
  ${({ theme, light, small }) => `
    color: ${
      light
        ? theme.colors.blackTextBody + theme.transparencies.p30
        : theme.colors.blackTextBody
    };
    font-size: ${small ? "1.2rem" : "1.4rem"};
  `}
  font-weight: 700;
`;

interface IText {
  small?: any;
}
export const Text = styled.p<IText>`
  ${({ theme, small }) => `
    color: ${theme.colors.blackTextBody};
    font-size: ${small ? "1.4rem" : "1.6rem"};
  `}
  font-weight: 500;
`;
